
























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class AngleSelector extends Vue {
  public canvas!: CanvasRenderingContext2D;
  public canvasElement: any;
  public axisOrigin = { x: 0, y: 300 };

  @Prop({
    default: () => ({
      referenceAngle: 0,
      inclinationAngle: 25,
    }),
  })
  public value: any;

  public mounted(): void {
    this.canvasElement = document.getElementById(
      'angle-selector-canvas',
    ) as HTMLCanvasElement;
    this.canvas = this.canvasElement.getContext('2d');
    this.draw();
  }

  public drawAxis(): void {
    this.canvas.strokeStyle = 'black';
    this.canvas.fillStyle = 'black';
    this.canvas.beginPath();
    this.canvas.moveTo(this.axisOrigin.x, this.axisOrigin.y);
    this.canvas.lineTo(this.axisOrigin.x, 0);
    this.canvas.stroke();

    this.canvas.moveTo(this.axisOrigin.x, this.axisOrigin.y);
    this.canvas.lineTo(300, this.axisOrigin.y);
    this.canvas.stroke();
  }

  public drawRef(): void {
    this.canvas.fillStyle = 'green';
    this.canvas.translate(0, 300);
    this.canvas.rotate(((270 + this.value.referenceAngle) * Math.PI) / 180);
    this.canvas.fillRect(0, 0, 250, 5);

    this.canvas.fillText('Aref', 260, 8);

    this.canvas.setTransform(1, 0, 0, 1, 0, 0);
  }

  public drawMax(): void {
    this.canvas.fillStyle = 'red';
    this.canvas.translate(0, 300);
    this.canvas.rotate(
      ((270 + this.value.referenceAngle + this.value.inclinationAngle) *
        Math.PI) /
        180,
    );
    this.canvas.fillRect(0, 0, 250, 5);
    this.canvas.fillText('Amax', 260, 8);

    this.canvas.setTransform(1, 0, 0, 1, 0, 0);
  }

  public drawRefAngle(): void {
    this.canvas.beginPath();
    this.canvas.fillStyle = 'lightgreen';
    this.canvas.moveTo(0, 300);
    this.canvas.arc(
      0,
      300,
      100,
      (270 * Math.PI) / 180,
      ((270 + this.value.referenceAngle + this.value.inclinationAngle) *
        Math.PI) /
        180,
    );
    this.canvas.closePath();
    this.canvas.fill();
  }

  public drawMaxangle(): void {
    this.canvas.beginPath();
    this.canvas.fillStyle = 'lightsalmon';
    this.canvas.moveTo(0, 300);
    this.canvas.arc(
      0,
      300,
      200,
      ((270 + this.value.referenceAngle + this.value.inclinationAngle) *
        Math.PI) /
        180,
      (360 * Math.PI) / 180,
    );
    this.canvas.closePath();
    this.canvas.fill();
  }

  public draw(): void {
    this.canvas.clearRect(
      0,
      0,
      this.canvasElement.width,
      this.canvasElement.height,
    );

    this.drawRefAngle();
    this.drawMaxangle();
    this.drawAxis();
    this.drawRef();
    this.drawMax();
  }

  public onAngleInputChange(): void {
    this.draw();
  }

  @Watch('value', { immediate: true })
  public onValueChange(): void {
    // eslint-disable-next-line eqeqeq
    if (this.value.referenceAngle == undefined) {
      this.value.referenceAngle = 0;
    }

    // eslint-disable-next-line eqeqeq
    if (this.value.inclinationAngle == undefined) {
      this.value.inclinationAngle = 25;
    }
  }
}
